import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next';

import { useTitle } from '../../../config/global';
import Add3DMedia from './Add3DMedia';
import Layout from '../../Layout/Layout'
import icon from '../../../assets/img/3d_primary.png'

import { FiEdit2, FiTrash2, FiPlusCircle } from "react-icons/fi";
import CreateEditCollection from './CreateEditCollection';
import { Image, Tooltip } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { MULTI_3D_TABLE_CONFIG } from '../../../Constants/datatables';
import { useDataTableContext } from '../../Contexts/DataTableContext';
import { useDeleteMedia } from '../../../queries/media';
import { setIsCreation } from '../../../redux/Slices/Apps/appsSlice';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { formatDateTime } from '../../../utils/datetime';

function Multi3DViewerIndex() {
  const { t } = useTranslation();
  useTitle('Multi-3d Viewer');

  const { totalRecords, lazyParams, setLazyParams, data, onPage, onSort, onFilter, getDataTable } = useDataTableContext();
  const openDialog = useSelector((state) => state.global.openDialog);
  const deleteRss = useDeleteMedia();
  const dispatch = useDispatch()
  const [selectedCollection, setSelectedCollection] = useState({});

  const fetchData = () => {
    setLazyParams(prev => ({
      ...prev, ...MULTI_3D_TABLE_CONFIG
    }))
  }

  useEffect(() => {
    fetchData()
  }, [])

  const deleteHandler = async (data) => {
    await deleteRss.mutateAsync(
      { id: data.id },
      {
        onSuccess: () => fetchData()
      });
  }

  const editRss = (rowData) => {
    setSelectedCollection(rowData)
    dispatch(setIsCreation(false))
    dispatch(toggleDialog("createEditCollection"))
  }

  const addContent = (rowData) => {
    setSelectedCollection(rowData)
    dispatch(toggleDialog("addCollectionContent"))
  }

  // Data Table Body Template
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="d-inline-block text-nowrap">
        {/* Add Content RSS */}
        <Tooltip target={`.add-button-${rowData.id}`} showDelay={100} className="fs-8" />
        <button className={`btn btn-sm btn-icon delete-record me-2 add-button-${rowData.id}`}
          data-pr-position="bottom"
          data-pr-tooltip={t('multi3d.tooltip_add_content')}
          onClick={() => addContent(rowData)} >
          <FiPlusCircle className="fs-5 fw-bold " />
        </button>

        {/* Update RSS */}
        <button className={`btn btn-sm btn-icon  me-2  update-button-${rowData.id}`} data-pr-position="bottom" data-pr-tooltip={t('multi3d.tooltip_update')} onClick={() => editRss(rowData)}>
          <FiEdit2 className="fs-5 fw-bold " />
        </button>

        {/* Delete RSS */}
        <button className={`btn btn-sm btn-icon delete-record me-2  delete-button-${rowData.id}`} data-pr-position="bottom" data-pr-tooltip={t('multi3d.tooltip_delete')} onClick={() => deleteHandler(rowData)} >
          <FiTrash2 className="fs-5 fw-bold " />
        </button>
      </div >
    );
  }

  const subNavbarProps = useMemo(() => {
    return {
      icon: <Image src={icon} width="30" /> || " ",
    };
  }, []);

  const subNavbarContent = useMemo(() => {
    return (
      <div className='flex justify-end w-100'>
        <button className="btn btn-primary mx-1 d-flex align-items-center"
          disabled={getDataTable.isLoading}
          onClick={() => dispatch(toggleDialog("createEditCollection"))} >
          <i className="fa-solid fa-plus me-1 fw-lighter fs-5 "></i>
          {t('multi3d.add_collection')}
        </button>
      </div>
    );
  }, [getDataTable.isLoading]);

  return (
    <Layout subNavbarProps={subNavbarProps} subNavbarContent={subNavbarContent}>
      <div className="card">
        <div className='table-responsive text-nowrap m-4'>
          <DataTable value={data?.media} lazy filterDisplay="row" responsiveLayout="scroll" dataKey="id"
            paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[15, 25, 50, 100]}
            totalRecords={totalRecords} onPage={onPage}
            onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
            onFilter={onFilter} filters={lazyParams.filters} loading={getDataTable.isLoading} className="table"
          >
            <Column field="file_name" header={t('table.name')} className='text-center' sortable filter filterPlaceholder={t('multi3d.filter_search_name')} />
            <Column field="created_at" header={t('multi3d.col_created_date')} className='text-center' sortable
                body={(r) => formatDateTime(r.created_at)} />
            <Column body={actionBodyTemplate} exportable={false} ></Column>
          </DataTable>
        </div>
      </div>
      {
        openDialog?.createEditCollection ? <CreateEditCollection selectedCollection={selectedCollection} /> : <></>
      }
      {
        openDialog?.addCollectionContent ? <Add3DMedia selectedCollection={selectedCollection} /> : <></>
      }

    </Layout >
  )
}

export default Multi3DViewerIndex